import {FC, isValidElement, ReactNode} from "react";
import {Flex, Tag, theme, Tooltip, Typography} from "antd";
import dayjs from "dayjs";
import {QuestionCircleFilled} from "@ant-design/icons";
import styles from './CommentPure.module.css';
import {User} from "../../../../../../types/domain.ts";
import {useOwnProfile} from "../../../../../../stores/OwnProfileStore.ts";
import {UserAvatar} from "../../../../../../components/UserAvatar/UserAvatar.tsx";
import {UserWithContacts} from "../../../../../../components/UserWithContacts/UserWithContacts.tsx";
import {ROLE_MAP} from "../../../../../../constants/constants.ts";

type Props = {
    user: User;
    createdAt: string;
    content: ReactNode;
    privateFor: User | null;
}

export const CommentPure: FC<Props> = ({ user, createdAt, content, privateFor }) => {
    const { profile } = useOwnProfile();
    const { token } = theme.useToken();

    return (
        <Flex align="center" gap={8}>
            <UserAvatar
                user={user}
                size={36}
                shape="square"
            />
            <Flex vertical>
                <Flex gap={8} align="center">
                    <Typography.Text strong>
                        <UserWithContacts user={user} /> ({ROLE_MAP[user.role]}) | {dayjs.utc(createdAt).format('DD.MM.YYYY HH:mm[Z]')}
                    </Typography.Text>
                    {privateFor && (
                        <Tooltip
                            title={privateFor.id === profile?.id ?
                                `Доступен вам, отправителю и стаффу` :
                                `Доступен вам, ${privateFor.first_name} ${privateFor.last_name} и стаффу`
                            }
                        >
                            <Tag color="red" className={styles.tag}>Приватный <QuestionCircleFilled style={{ color: token.colorErrorBorderHover }} /></Tag>
                        </Tooltip>
                    )}
                </Flex>
                {isValidElement(content) ? content : <Typography.Text>{content}</Typography.Text>}
            </Flex>
        </Flex>
    )
}